import { render, staticRenderFns } from "./ExtraAccesses.vue?vue&type=template&id=38d30e61&scoped=true"
import script from "./ExtraAccesses.vue?vue&type=script&lang=js"
export * from "./ExtraAccesses.vue?vue&type=script&lang=js"
import style0 from "./ExtraAccesses.vue?vue&type=style&index=0&id=38d30e61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d30e61",
  null
  
)

export default component.exports